import { Col, Row, Typography } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import CleanButton from "../../common/components/CleanButton";
import Page from "../../common/components/Page";
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { useGetAllConfigsQuery, useVerifyCaptchaMutation } from "../../state/globalApi";
import getConfigs from "../../GetConfigs";
import { buildLookupRequest } from "../../state/connect-api";
import { setConfig } from "../../state/globalStore";
import { useDispatch } from "react-redux";


const DisclaimerStartPage = () => {
  const navigate = useNavigate();
  const [captchaVerification] = useVerifyCaptchaMutation();
  const agencyCaptcha = useRef(null);
  const dispatch = useDispatch();
  const disclaimerCaptcha = useRef(null);
  const { data: configData } = useGetAllConfigsQuery(buildLookupRequest());

  useEffect(() => {
    dispatch(setConfig(configData?.Data));
  }, [configData]);

  const configurations = getConfigs([
    "ctAgencyLogin",
    "captchaEnabled",
    "ctDisclaimerTxt"
  ]);
  const [loading, setLoading] = useState<boolean>(false);

  const captchaCheck = async (button: string) => {
    if (button == "Agency") {
      if (configurations.captchaEnabled == "true") {
        setLoading(true);
        agencyCaptcha.current.execute();
      }
      else {
        navigate("login");
      }

    }
    else if (button == "Disclaimer") {
      if (configurations.captchaEnabled == "true") {
        setLoading(true);
        disclaimerCaptcha.current.execute();
      }
      else {
        document.cookie = `isLoggedIn=1;expires=${new Date(new Date().getTime() + 24 * 60 * 60 * 1000)};path=/`;
        navigate("/home");
      }
    }
  };

  const acceptAgency = () => {
    navigate("/login");
  };
  const verifyDisclaimer = async (token) => {
    var captcha = await captchaVerification(token).unwrap();
    if (captcha) {
      document.cookie = `isLoggedIn=1;expires=${new Date(new Date().getTime() + 24 * 60 * 60 * 1000)};path=/`;
      navigate("/home");
    }
    setLoading(false);
  }
  const verifyAgency = async (token) => {
    var captcha = await captchaVerification(token).unwrap();
    if (captcha) {
      navigate("login");
    }
    setLoading(false);
    }
  return (
    <Page>
      <script src="https://js.hcaptcha.com/1/api.js" async defer></script>
      <Page.Content>
        <Row gutter={[12, 12]}>
          <Typography.Title level={2}>Court Connect General Disclaimer</Typography.Title>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
             <div dangerouslySetInnerHTML={{ __html: configurations?.ctDisclaimerTxt }} />
          </Col>
          <CleanButton onClick={() => captchaCheck("Disclaimer")} icon={"check"} loading={loading} disabled={!configurations?.ctDisclaimerTxt }>
            I Accept, Continue
          </CleanButton>
          <Col>
          </Col>
          {(configurations?.ctAgencyLogin && configurations?.ctAgencyLogin.toLowerCase() === "true" )&& (
            <Col>
              <CleanButton onClick={() => captchaCheck("Agency")} icon={"university"} loading={loading}>
                Agency Access
              </CleanButton>

            </Col>
          )}
        </Row>
        <HCaptcha
          sitekey="18b76bdc-7767-4393-8519-6f95a63e23bb"
          onVerify={verifyAgency}
          onClose={() => setLoading(false)}
          size="invisible"
          ref={agencyCaptcha}
        />
        <HCaptcha
          sitekey="18b76bdc-7767-4393-8519-6f95a63e23bb"
          onVerify={verifyDisclaimer}
          onClose={() => setLoading(false)}
          size="invisible"
          ref={disclaimerCaptcha}
        />
      </Page.Content>
    </Page>
  );
};

export default DisclaimerStartPage;
